import va1stScience from "./va1stScienceQuizContent";
import va1stSocialStudies from "./va1stSocialStudiesQuizContent";
import va1stMath from "./va1stMathQuizContent";
import va1stOther from "./va1stOtherQuizContent";

// 2nd Grade
import va2ndScience from "./va2ndScienceQuizContent";
import va2ndSocialStudies from "./va2ndSocialStudiesQuizContent";
import va2ndMath from "./va2ndMathQuizContent";
import va2ndOther from "./va2ndOtherQuizContent";

// 3rd Grade
import va3rdScience from "./va3rdScienceQuizContent";
import va3rdSocialStudies from "./va3rdSocialStudiesQuizContent";
import va3rdMath from "./va3rdMathQuizContent";
import va3rdOther from "./va3rdOtherQuizContent";

// 4th Grade
import va4thScience from "./va4thScienceQuizContent";
import va4thSocialStudies from "./va4thSocialStudiesQuizContent";
import va4thMath from "./va4thMathQuizContent";
import va4thOther from "./va4thOtherQuizContent";

// 5th Grade
import va5thScience from "./va5thScienceQuizContent";
import va5thSocialStudies from "./va5thSocialStudiesQuizContent";
import va5thMath from "./va5thMathQuizContent";
import va5thOther from "./va5thOtherQuizContent";
// ...import the rest as you add them

// Keep your existing keys ← these are what MapPage already uses
export const vatopicsMapBySubject = {
  // 1st Grade
va_1st_science: va1stScience,
va_1st_socialstudies: va1stSocialStudies,
va_1st_math: va1stMath,
va_1st_other: va1stOther,

// 2nd Grade
va_2nd_science: va2ndScience,
va_2nd_socialstudies: va2ndSocialStudies,
va_2nd_math: va2ndMath,
va_2nd_other: va2ndOther,

// 3rd Grade
va_3rd_science: va3rdScience,
va_3rd_socialstudies: va3rdSocialStudies,
va_3rd_math: va3rdMath,
va_3rd_other: va3rdOther,

// 4th Grade
va_4th_science: va4thScience,
va_4th_socialstudies: va4thSocialStudies,
va_4th_math: va4thMath,
va_4th_other: va4thOther,

// 5th Grade
va_5th_science: va5thScience,
va_5th_socialstudies: va5thSocialStudies,
va_5th_math: va5thMath,
va_5th_other: va5thOther,
  // ...add the rest
};
